





































































import { AuthApiClient } from "@/api/auth_client";
import { AuthResponse } from "@/interfaces/auth";
import { Component, Vue } from "vue-property-decorator";
import CardComponent from "@/components/CardComponent.vue";

@Component({
  components: {
    CardComponent
  }
})
export default class Activate extends Vue {
  private api = new AuthApiClient();

  private isLoading = false;
  private message = "";

  private form: any = {
    username: "",
    code: ""
  };

  mounted() {
    if (this.$store.state.userEmail) {
      this.form.username = this.$store.state.userEmail;
    }
  }

  submit() {
    this.isLoading = true;

    this.api
      .activate(this.form.username, this.form.code)
      .then((response: AuthResponse) => {
        if (response.ok) {
          this.$buefy.toast.open({
            message: this.$t("auth.activate.success"),
            type: "is-info",
            queue: false
          });

          this.$router.push("/login");
        }
      })
      .catch(error => {
        if (typeof error === "string") {
          this.message = this.$t(error);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  sendCode() {
    this.isLoading = true;

    this.api
      .sendNewCode(this.form.username)
      .then((response: AuthResponse) => {
        if (response.ok) {
          this.$buefy.toast.open({
            message: this.$t("auth.activate.codeSent"),
            type: "is-info",
            queue: false
          });
        }
      })
      .catch(error => {
        if (typeof error === "string") {
          this.message = this.$t(error);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
